import {
  Button,
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Link from "next/link";
import PropTypes from "prop-types";

const KnowledgeEntry = ({ entry, ...props }) => {
  const KnowledgeEntryStyled = styled((props) => (
    <Card elevation={0} {...props} />
  ))(({ theme }) => ({
    borderStyle: "solid",
    borderColor: grey[400],
    borderWidth: "1px",
    backgroundColor: "transparent",
    transition: "all .2s ease-out",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      "& .MuiTypography-root": {
        color: theme.palette.common.white,
      },
      "& .MuiButton-root": {
        color: theme.palette.common.white,
        borderColor: theme.palette.common.white,
      },
    },
    "& .MuiCardContent-root": {
      padding: "1rem",
    },
    "& .MuiTypography-root": {
      textTransform: "uppercase",
      fontSize: "1.375rem",
    },
  }));

  return (
    <KnowledgeEntryStyled className="knowledge--entry">
      <CardActionArea
        component={Link}
        href={`/foerderung/wissenswertes/${entry.slug}`}
      >
        <CardContent>
          <Grid
            container
            spacing={3}
            alignItems="center"
            justifyContent="space-between"
          >
            <Grid item xs={12} md={6}>
              <Typography color="common.black">{entry.title}</Typography>
            </Grid>
            <Grid item xs={12} md="auto">
              <Button fullWidth variant="outlined" color="secondary">
                Zum Artikel
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </KnowledgeEntryStyled>
  );
};

KnowledgeEntry.propTypes = {
  entry: PropTypes.object.isRequired,
};

export default KnowledgeEntry;
